// floating labels for all browsers
(function () {
  try {
    // Handle floating labels for all browsers
    function handleFloatingLabels() {
      const inputs = document.querySelectorAll('.cf-input-with-overlay');

      inputs.forEach((input) => {
        function updateLabel() {
          const hasValue = input.value.trim() !== '';
          const isFocused = document.activeElement === input;

          // Use .focused class on input
          if (hasValue || isFocused) {
            input.classList.add('focused');
          } else {
            input.classList.remove('focused');
          }
        }

        // Initial check
        updateLabel();

        // Add event listeners
        input.addEventListener('input', updateLabel);
        input.addEventListener('blur', updateLabel);
        input.addEventListener('focus', updateLabel);
        input.addEventListener('change', updateLabel);
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleFloatingLabels);
    } else {
      handleFloatingLabels();
    }

    // Run after delays to catch dynamic content
    setTimeout(handleFloatingLabels, 100); // Keep just one short delay

    // Also run when new content is added (for dynamic forms)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const hasNewInputs = Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === 1 &&
              (node.classList?.contains('cf-input-with-overlay') || node.querySelector?.('.cf-input-with-overlay'))
          );
          if (hasNewInputs) {
            setTimeout(handleFloatingLabels, 50);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  } catch (error) {
    console.error('Error in floating label fix:', error);
  }
})();
